var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SelectArea',{ref:"external-access-select-area",attrs:{"product-source":_vm.productSource},on:{"select-section":_vm.selectSection}})}
var staticRenderFns = []

export { render, staticRenderFns }